export { RunTimeConfig } from './run-time-config.interface';
export { getRuntimeConfig, setRunTimeConfig } from './run-time-config.utils';
